module.exports = {
	"pagination": {
		"ListAliases": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Aliases"
		},
		"ListGrants": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Grants"
		},
		"ListKeyPolicies": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "PolicyNames"
		},
		"ListKeys": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Keys"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kms-2014-11-01.paginators.json
// module id = 713
// module chunks = 2